export default __webpack_public_path__ + "static/media/splachLogo.b2cf9e27.webp";